import React from 'react';
import { Shield, Lock, TrendingUp, Globe, Scale, Building } from 'lucide-react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: Shield,
      title: "Nationwide Legal Protection",
      description: "Federal trademark registration provides exclusive rights to use your mark across all 50 states, giving you comprehensive nationwide protection against infringement and unauthorized use.",
      highlight: "Protect your brand coast to coast"
    },
    {
      icon: Lock,
      title: "Exclusive Brand Rights",
      description: "Gain the legal right to use the ® symbol and prevent competitors from using confusingly similar marks in your industry, establishing clear ownership of your brand identity.",
      highlight: "Your brand, your exclusive right"
    },
    {
      icon: TrendingUp,
      title: "Increased Brand Value",
      description: "A registered trademark is a valuable business asset that appreciates over time. It enhances your company's valuation, attracts investors, and strengthens your market position.",
      highlight: "Build valuable intellectual property"
    },
    {
      icon: Globe,
      title: "E-Commerce & Online Protection",
      description: "Essential for domain name protection, social media verification, and online marketplace credibility. Registered trademarks help combat counterfeiters and protect your digital presence.",
      highlight: "Secure your online identity"
    },
    {
      icon: Scale,
      title: "Legal Enforcement Power",
      description: "Federal registration provides legal presumption of ownership and validity, making it easier to enforce your rights in court, seek damages, and obtain cease and desist compliance.",
      highlight: "Strong legal foundation for disputes"
    },
    {
      icon: Building,
      title: "Business Expansion Support",
      description: "A registered trademark facilitates franchising, licensing opportunities, and geographic expansion. It's essential for scaling your business and entering new markets with confidence.",
      highlight: "Foundation for growth and licensing"
    }
  ];

  return (
    <section className="benefits-section" id="benefits">
      <div className="section-container">
        <div className="section-header-center">
          <span className="section-label">Benefits of Registration</span>
          <h2 className="section-title">
            Why Trademark Registration
            <span className="title-highlight"> Matters for Your Business</span>
          </h2>
          <p className="section-description">
            Federal trademark registration isn't just legal protection—it's a strategic 
            business investment that provides tangible benefits, competitive advantages, 
            and long-term value for your brand.
          </p>
        </div>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div key={index} className="benefit-card">
                <div className="benefit-icon-container">
                  <Icon size={36} className="benefit-icon" />
                </div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
                <div className="benefit-highlight">
                  <span className="highlight-dot"></span>
                  <span className="highlight-text">{benefit.highlight}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Key Statistics */}
        <div className="benefits-stats">
          <div className="benefit-stat-card">
            <div className="stat-number">10 Years</div>
            <div className="stat-label">Initial Registration Period</div>
            <div className="stat-description">Renewable indefinitely</div>
          </div>
          <div className="benefit-stat-card">
            <div className="stat-number">$2M+</div>
            <div className="stat-label">Average Brand Value Increase</div>
            <div className="stat-description">With federal protection</div>
          </div>
          <div className="benefit-stat-card">
            <div className="stat-number">5x</div>
            <div className="stat-label">Easier Legal Enforcement</div>
            <div className="stat-description">vs. unregistered marks</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
